import React, {
	useEffect, useState,
} from 'react';
import Loader from 'react-ts-loaders';
import _ from 'lodash';
import { privateTemplateTagAPI } from '../../../../../../entities/template/private-template-tag';
import { templateTagGroupApi } from '../../../../../../entities/template/private-template-tag-group';
import { MultipleContainers } from '../multipleContainers/MultipleContainers';
import { ITagGroup, TagGroupType } from '../../../../../../entities/template/private-template-tag-group/model/types';

/**
 * Настройка тегов (и их групп) приватных шаблонов
 */
export const PrivateTemplateTagGroupSettings = () => {
	const [groups, setGroups] = useState<ITagGroup[]>();

	const {
		isLoading: isLoadingTagGroups,
		data: tagGroupsData,
	} = templateTagGroupApi.useGetTemplateGroupsQuery({
		page: 1, limit: 127, search: '',
	});
	const {
		isLoading: isLoadingTagsWithoutGroups,
		data: tagsWithoutGroupsData,
	} = privateTemplateTagAPI.useGetTagsWithoutGroupsQuery({
		limit: 127, page: 1,
	});

	// Объединяем состояния загрузки
	const isLoading = isLoadingTagGroups || isLoadingTagsWithoutGroups;

	useEffect(() => {
		setGroups(() => {
			const items = _.cloneDeep(tagGroupsData?.groupTags) ?? [];
			const unbind = _.cloneDeep(tagsWithoutGroupsData?.templateTags) ?? [];
			items.unshift({
				id: TagGroupType.tagsWithoutGroup,
				name: 'Без группы',
				tags: unbind,
			});
			return items;
		});
	}, [tagsWithoutGroupsData?.templateTags, tagGroupsData]);

	if (isLoading) {
		return (
			<Loader
				type="roller"
				color="rgba(57, 150, 218, 1)"
				size={100}
				className="alt-loader"
			/>
		);
	}

	return (
		<div>
			{groups
				? (
					<MultipleContainers
						handle
						items={groups}
					/>
				)
				: 'Загрузка'}
		</div>
	);
};
